import { Box, Stepper, Typography } from "@mui/material";
import React from "react";
import { EphemeralAdvisor, FormErrors } from "./types";
import ContactStep, {
  ContactFields,
  EmergencyContactFields,
} from "./steps/ContactStep";
import PersonalDetailsStep, {
  PersonalDetailsFields,
} from "./steps/PersonalDetailsStep";
import AdvisorContactStep from "./steps/AdvisorContactStep";
import SubmissionStep from "./steps/SubmissionStep";
import { ContactCard } from "components/common/ContactCardEntry";

interface Props {
  formData: EphemeralAdvisor;
  updateFormData: (f: EphemeralAdvisor) => void;
  errors: FormErrors | null;
  onSubmit: () => void;
  loading: boolean;
  editMode?: boolean;
  actionName?: string;
  disabled?: boolean;
}

export default ({
  loading,
  errors,
  formData,
  updateFormData,
  onSubmit,
  editMode = false,
  disabled = false,
  actionName = "Create Account",
}: Props) => {
  const [activeStep, setActiveStep] = React.useState(0);

  const handleNext = () => {
    setActiveStep((prevActiveStep) => prevActiveStep + 1);
  };

  const handleBack = () => {
    setActiveStep((prevActiveStep) => prevActiveStep - 1);
  };

  if (editMode) {
    return (
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          gap: "24px",
          paddingTop: "8px",
          paddingBottom: "8px",
        }}
      >
        <Box>
          <Typography variant="h4" sx={{ marginBottom: "8px" }}>
            Contact Information
          </Typography>
          <ContactFields
            formData={formData}
            updateFormData={updateFormData}
            errors={errors}
          />
        </Box>
        <Box>
          <Typography variant="h4" sx={{ marginBottom: "8px" }}>
            Emergency Contact
          </Typography>
          <EmergencyContactFields
            formData={formData}
            updateFormData={updateFormData}
          />
        </Box>
        <Box>
          <Typography variant="h4" sx={{ marginBottom: "8px" }}>
            Personal Details
          </Typography>
          <PersonalDetailsFields
            formData={formData}
            updateFormData={updateFormData}
            errors={errors}
          />
        </Box>
        <Box>
          <Typography variant="h4" sx={{ marginBottom: "16px" }}>
            Faye Contact Card
          </Typography>
          <ContactCard
            fullName={`${formData.firstName} ${formData.lastName}`}
            tel={formData.advisorPhone || ""}
            email={formData.username || ""}
          />
        </Box>
      </Box>
    );
  }

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        gap: "10px",
        marginBottom: "20px",
      }}
    >
      <Stepper activeStep={activeStep} orientation="vertical">
        <ContactStep
          formData={formData}
          updateFormData={updateFormData}
          errors={errors}
          handleNext={handleNext}
        />
        <PersonalDetailsStep
          formData={formData}
          updateFormData={updateFormData}
          errors={errors}
          handleNext={handleNext}
          handleBack={handleBack}
        />
        {!editMode && (
          <AdvisorContactStep
            activeStep={activeStep}
            formData={formData}
            updateFormData={updateFormData}
            errors={errors}
            handleNext={handleNext}
            handleBack={handleBack}
          />
        )}
        <SubmissionStep
          formData={formData}
          errors={errors}
          updateFormData={updateFormData}
          actionName={actionName}
          handleBack={handleBack}
          onSubmit={onSubmit}
          loading={loading}
          editMode={editMode}
          disabled={disabled}
        />
      </Stepper>
    </Box>
  );
};
